/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import navListRoutes from "../../../router/navListRoutes";
import { NavSection } from "../../organisms";
import * as styles from "./index.styles";
import { useNavigate } from "react-router-dom";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const goToHome = () => {
    navigate("/");
  };

  return (
    <aside css={styles.root(isCollapsed)}>
      <button
        type="button"
        css={styles.collapseButton}
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? "Mostrar menú" : "Ocultar menú"}
      >
        {isCollapsed ? "›" : "‹"}
      </button>

      {!isCollapsed && (
        <img
          src="/logo.svg"
          alt="logo"
          width={167}
          css={{ marginBottom: "46px", cursor: "pointer" }}
          onClick={goToHome}
        />
      )}

      <nav css={styles.nav(isCollapsed)}>
        {navListRoutes.map((routeSection) => (
          <NavSection
            key={`sidebarSection-${routeSection.title}`}
            routeSection={routeSection}
            isCollapsed={isCollapsed}
          />
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;